(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noxoro-drop-001"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('noxoro-drop-gallery')) {
    customElements.define('noxoro-drop-gallery', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const { signal } = this.controller;
        const track = this.querySelector('.noxoro-drop-gallery__track');
        const slides = [...this.querySelectorAll('.noxoro-drop-gallery__slide')];
        const thumbs = [...this.querySelectorAll('.noxoro-drop-gallery__thumb')];
        const count = this.querySelector('.noxoro-drop-gallery__count');
        if (!track || !slides.length) return;
        let selected = 0;
        let requested = 0;
        const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        const go = (index) => {
          requested = Math.max(0, Math.min(slides.length - 1, index));
          const offset = slides[requested].getBoundingClientRect().left - track.getBoundingClientRect().left;
          track.scrollBy({ left: offset, behavior: reducedMotion.matches ? 'instant' : 'smooth' });
        };
        thumbs.forEach((thumb, index) => {
          thumb.addEventListener('click', (event) => {
            event.preventDefault();
            go(index);
          }, { signal });
        });
        this.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const rtl = getComputedStyle(track).direction === 'rtl';
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : requested + ((event.key === 'ArrowRight') !== rtl ? 1 : -1);
          go(next);
          if (event.target.closest('.noxoro-drop-gallery__thumb')) thumbs[requested]?.focus({ preventScroll: true });
        }, { signal });
        const update = () => {
          const edge = track.getBoundingClientRect().left;
          const index = slides.reduce((best, slide, i) => Math.abs(slide.getBoundingClientRect().left - edge) < Math.abs(slides[best].getBoundingClientRect().left - edge) ? i : best, 0);
          if (index === selected) return;
          selected = index;
          thumbs.forEach((thumb, i) => {
            if (i === selected) thumb.setAttribute('aria-current', 'true');
            else thumb.removeAttribute('aria-current');
          });
          if (count) count.textContent = `${index + 1} / ${slides.length}`;
          const active = thumbs[index];
          if (active) {
            const row = active.parentElement;
            const itemRect = active.getBoundingClientRect();
            const rowRect = row.getBoundingClientRect();
            if (itemRect.left < rowRect.left || itemRect.right > rowRect.right) {
              row.scrollBy({ left: itemRect.left - rowRect.left - (row.clientWidth - active.clientWidth) / 2, behavior: 'instant' });
            }
          }
        };
        track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(update);
          clearTimeout(this.settled);
          this.settled = setTimeout(() => { update(); requested = selected; }, 150);
        }, { signal, passive: true });
      }
      disconnectedCallback() {
        this.controller?.abort();
        cancelAnimationFrame(this.frame);
        clearTimeout(this.settled);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
